import React from "react";
import { forgetpassword } from "../api/authApi";
import IsValidSignUpData from "./ValidationChecker/signupValidation";
import AuthForm from "./common/authForm/AuthForm";

const ForgotPassword = () => {
  const handleSubmit = (values, callback) => {
    forgetpassword({ email: values.email }, callback);
  };

  const customFields = [
    {
      name: "email",
      type: "email",
      placeholder: "E-Mail",
      label: "Email Address",
    },
  ];

  return (
    <AuthForm
      formType="Forgot Password"
      initialValues={{ email: "" }}
      validationFunc={IsValidSignUpData}
      onSubmit={handleSubmit}
      successRedirectPath=""
      buttonLabel="Send Reset Link"
      loadingLabel="Sending..."
      customLinks={[
        { to: "/login", label: "Back to Log-In", },
      ]}
      customFields={customFields}
      subTitle = "Enter your email to reset your password"
    />
  );
};

export default ForgotPassword;
